import React from "react";
import "./OraclePowerUP.css";

function OraclePowerUP() {
  const mailId = "ATCI.L-TT.Oracle";
  const domain = "accenture.com";
  return (
    <>
      <div className="oracle-powerup-container">
        <div className="oracle-powerup-wrap">
          <h2>Ready to get Oracle-certified and elevate your game?</h2>
          <p>
            Gear up for the ultimate Oracle league, where every certification is
            a goal and every skill upgrade is a victory.
          </p>
          <p>
            Take up Oracle certifications in current and new skills, claim your
            trophy, and rise to the top!
          </p>
          <div className="oracle-powerup-extra-row">
            <h3>Play across three power arenas</h3>
            <div className="oracle-powerup-row row1">
              <div className="oracle-powerup-box">
                <h3>Arena 1</h3>
                <p>
                  Step onto the field with a solid foundation. Master core AI,
                  GenAI, and Agentic AI fundamentals.
                </p>
                <p>
                  Who is it for? <span>Across ATCI</span>
                </p>
                <p className="link-head">Sign up here and join the game</p>
                <p className="arena-links">
                  <a target="blank" href="https://mylearn.oracle.com/ou/learning-path/become-an-oci-ai-foundations-associate-2025/147781">
                    AI
                  </a>
                  <a target="blank" href="https://mylearn.oracle.com/ou/learning-path/become-an-oci-generative-ai-professional/148888">
                    GenAI
                  </a>
                  <a target="blank" href="https://mylearn.oracle.com/ou/learning-path/oracle-ai-agent-studio-for-fusion-applications-foundations-associate-training-and-certification/151552">
                    Agentic AI Fundamentals
                  </a>
                </p>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/Programs/Oracle-arena-icon1.png"
                  }
                  alt="Oracle Arena"
                  className="Oracle-arena-icon"
                />
              </div>
            </div>
            <div className="oracle-powerup-row row2">
              <div className="oracle-powerup-box">
                <h3>Arena 2</h3>
                <p>
                  Take the Agentic AI Developer certification and work hands-on
                  to create real-world solutions.
                </p>
                <p>
                  Who is it for? <span>Oracle BG - All levels</span>
                </p>
                <p className="link-head">Register here and join the game</p>
                <p className="arena-links">
                  <a target="blank" href="https://mylearn.oracle.com/ou/learning-path/oracle-ai-agent-studio-for-fusion-applications-developers-training-and-certification/154448">
                    Agentic AI Developer certification
                  </a>
                </p>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/Programs/Oracle-arena-icon2.png"
                  }
                  alt="Oracle Arena"
                  className="Oracle-arena-icon"
                />
              </div>
            </div>
            <div className="oracle-powerup-row row3">
              <div className="oracle-powerup-box">
                <h3>Arena 3</h3>
                <p>
                  Take charge of the field by earning or renewing your PaaS and
                  SaaS certifications.
                </p>
                <p>
                  Who is it for?{" "}
                  <span>
                    Oracle BG - All levels and individuals whose certification
                    is due for renewal
                  </span>
                </p>
                <p className="link-head">Enroll here and join the game</p>
                <p className="arena-links">
                  <a target="blank" href="https://mylearn.oracle.com/ou/story/35644">PaaS</a>
                  <a target="blank" href="https://mylearn.oracle.com/ou/story/146587">SaaS</a>
                </p>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/Programs/Oracle-arena-icon3.png"
                  }
                  alt="Oracle Arena"
                  className="Oracle-arena-icon"
                />
              </div>
            </div>
          </div>
          <div className="oracle-queries-box">
            <p>
              For queries, write to -{" "}
              <a href="mailto:ATCI.L-TT.Oracle;">
                {mailId}@{domain}
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default OraclePowerUP;
